import { CommanderThunkAction } from '@mews-commander/types';
import { GeneralSubscription } from '@mews-commander/data-access';
import { getFullName } from '@mews-commander/utils';
import { getCurrentEnterpriseId, getCurrentProfileId, getCurrentUser } from '@mews-commander/core';
import { getCurrentEnterpriseSubscription } from '@mews-commander/legacy-entities/src/selectors/session/subscription';
import { getScopeByProfileId } from '@mews-commander/legacy-entities/src/ducks/scopes';
import { getPlatformEnvironment } from '../reducers/configuration';

export const setFullviewUser =
    (): CommanderThunkAction =>
    (dispatch, getState, { fullviewService }) => {
        const state = getState();
        const { id, email, firstName, lastName } = getCurrentUser();
        const environment = getPlatformEnvironment();
        const { supportTier, crmIdentifier }: GeneralSubscription = getCurrentEnterpriseSubscription(state);
        const enterpriseId = getCurrentEnterpriseId();
        const profileId = getCurrentProfileId();
        const { privileges = {} } = getScopeByProfileId(state, {
            profileId,
        }) ?? { privileges: {} };

        const roles = Object.entries(privileges)
            .filter(([_, value]) => value === true)
            .map(([key]) => key);

        const fullName =
            typeof firstName === 'string' && typeof lastName === 'string' ? getFullName({ firstName, lastName }) : '';

        const options = {
            id,
            name: fullName,
            email: typeof email === 'string' ? email : '',
            disableReplaysForUser: false,
            env: `Operations ${environment}`,
            roles,
            customField: {
                supportTier,
                crmIdentifier: typeof crmIdentifier === 'string' ? crmIdentifier : '',
                enterpriseId,
            },
        };

        fullviewService.setUser(options);
    };
